<template>
  <div :class="classObject" ref="tooltip" @mouseover="onMouseOver">
    <slot></slot>
    <div class="c-tooltip__inner" ref="inner" :style="innerStyleObject">
      <span class="c-tooltip__text">{{text}}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'base-tooltip',

  props: {
    text: String,
    followCursor: {
      type: Boolean,
      default: true,
    },
    fillContainer: Boolean,
  },

  data() {
    return {
      posX: null,
      posY: null,
      show: false,
    };
  },

  methods: {
    onMouseOver(e) {
      const innerRect = this.$refs.inner.getBoundingClientRect();
      const margin = innerRect.width / 2;

      this.posX = e.clientX - margin;
      this.posY = e.clientY + 20;

      setTimeout(() => {
        this.show = true;
      }, 200);
    },
  },

  computed: {
    classObject() {
      return {
        'c-tooltip': true,
        'c-tooltip--follow-cursor': this.followCursor,
        'c-tooltip--show': this.show,
        'c-tooltip--fill-container': this.fillContainer,
      };
    },

    innerStyleObject() {
      return {
        top: `${this.posY}px`,
        left: `${this.posX}px`,
      };
    },
  },
};
</script>

<style lang="scss">
.c-tooltip {
  display: inline-block;
  position: relative;
  transform: none;

  &__inner {
    display: block;
    visibility: hidden;
    opacity: 0;
    background: $colour-nhs-white;
    border-radius: 4px;
    padding: 1em;
    box-shadow: 0px 2px 6px rgba(0, 0, 0, 0.15);

    position: fixed;
    z-index: 99999;
    width: auto;
    overflow: hidden;

    transition: opacity 0.3s ease;
  }

  &__text {
    font-size: 14px;
    color: $colour-nhs-dark-grey;
  }

  &--show:hover &__inner {
    visibility: visible;
    opacity: 1;
  }

  &--fill-container {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;

    display: flex;
    align-items: center;
    justify-content: center;
  }
}
</style>
